import axios from 'axios';

// Create API instance
const api = axios.create({
  baseURL: ACADEMIC_URL,
});

api.defaults.headers.common['Content-Type'] = 'application/json; charset=utf-8';
api.defaults.headers.common['dataType'] = 'json'; // eslint-disable-line dot-notation

api.interceptors.response.use(
  response => response.data,
  error => Promise.reject(error),
);

// API functions
function login(credentials) {
  return api.post('/v1/security/brochureLogin', {
    username: credentials.username,
    password: credentials.password
  })
    .then((data) => {
      // Redirect to other application
      window.location.href = data.location;
    });
}

function isAccountLocked() {
  return false;
}

function registerHcp(user, inviteKey) {
  const inviteParam = inviteKey ? `?inviteKey=${inviteKey}` : '';
  return api.post(`/v1/signup/hcp${inviteParam}`, user);
}

function registerTrainee(user, inviteKey) {
  const inviteParam = inviteKey ? `?inviteKey=${inviteKey}` : '';
  return api.post(`/v1/signup/trainee${inviteParam}`, user);
}

function registerSupervisor(user, inviteKey) {
  const inviteParam = inviteKey ? `?inviteKey=${inviteKey}` : '';
  return api.post(`/v1/signup/supervisor${inviteParam}`, user);
}

function registerHod(user, inviteKey) {
  const inviteParam = inviteKey ? `?inviteKey=${inviteKey}` : '';
  return api.post(`/v1/signup/hod${inviteParam}`, user);
}

function lookupDisciplines() {
  return api.get('/v1/lookup/disciplines');
}

function lookupLogbookCountries() {
  return api.get('/v1/lookup/countries');
}

function lookupSpecialities(disciplineId) {
  return api.get(`/v1/lookup/discipline/${disciplineId}/specialities`);
}

function lookupGrades(specialityId) {
  return api.get(`/v1/lookup/speciality/${specialityId}/grades`);
}

function lookupRoles() {
  return api.get('/v2/lookups/roles');
}

function lookupInstitutions() {
  return api.get('/v2/lookups/trainingInstitutions');
}

function searchHods(query) {
  return api.get('/v2/departments/searchHod', {
    params: query,
  });
}

function requestPasswordReset(username) {
  return api.post('v1/security/passwordreset/', username)
    .then(() => Promise.resolve({ otpAvailable: false }));
}

function performPasswordReset(credentials) {
  return api.post('v1/security/changepassword', credentials);
}

function verifyEmail(verifyEmailData) {
  return api.post('v1/signup/verifyEmail', verifyEmailData);
}

function fetchInviteData(inviteKey) {
  return api.get(`v1/signup/invite/${inviteKey}`);
}

export default {
  login,
  isAccountLocked,
  registerHcp,
  registerTrainee,
  registerSupervisor,
  registerHod,
  lookupDisciplines,
  lookupLogbookCountries,
  lookupSpecialities,
  lookupGrades,
  lookupRoles,
  lookupInstitutions,
  searchHods,
  requestPasswordReset,
  performPasswordReset,
  verifyEmail,
  fetchInviteData,
};



// WEBPACK FOOTER //
// ./src/api/Academic.js